'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getCalendarMonthWeeks = {};

exports.__exports = getCalendarMonthWeeks;
